import { formatDurationAsDaysHrsMins, formatDateDefault } from 'services/DateFormatters';
import { isDateTimeBetween }  from 'services/DateService';
import { getProjectIssueCacheExpiry } from 'services/environment';
import { getDescriptionContent, getSubtasksReduced } from './jiraService';


export const mapIssuesInwardDependenciesToDisplayData = (allProjectIssues, projectIssue) => {
    return mapIssuesDependenciesToDisplayData(allProjectIssues, projectIssue, true);
};

export const mapIssuesOutwardDependenciesToDisplayData = (allProjectIssues, projectIssue) => {
    return mapIssuesDependenciesToDisplayData(allProjectIssues, projectIssue, false);
};


export const mapIssuesDependenciesToDisplayData = (allProjectIssues, projectIssue, inward) => {
    let projectDependencyData;
    if (Array.isArray(projectIssue?.fields?.issuelinks) && projectIssue?.fields?.issuelinks?.length > 0) {
        projectDependencyData = new Array();
        projectIssue?.fields?.issuelinks?.map((link) => {
            let linkedIssueId = 0;
            if (inward) {
                if (link?.inwardIssue !== undefined) {
                    linkedIssueId = link?.inwardIssue?.id;
                }
            } else {
                if (link?.outwardIssue !== undefined) {
                    linkedIssueId = link?.outwardIssue?.id;
                }
            }
            const foundIssue = allProjectIssues?.find((element) => element?.id === linkedIssueId);
            if (foundIssue) {
                projectDependencyData.push(getIssueDisplayData(foundIssue));
            }
        });
    }
    return projectDependencyData;
};

export const getIssueDisplayData = (projectIssue) => {
    const fields = { ...projectIssue?.fields };
    if (fields) {
        return {
            id: projectIssue?.id,
            summary: fields?.summary ? fields?.summary : 'No summary specified',
            description: getDescriptionContent(fields?.description),
            issueType: fields?.issuetype?.name,
            priority: fields?.priority?.name,
            status: fields?.status?.name,
            progress: formatDurationAsDaysHrsMins(fields?.progress?.progress),
            progressTotal: formatDurationAsDaysHrsMins(fields?.progress?.total),
            created: formatDateDefault(fields?.created),
            resolutionDate: fields?.resolutiondate ? formatDateDefault(fields?.resolutiondate) : 'This issue has not been resolved',
            resolution: fields?.resolution ? true : false,
            resolutionType: fields?.resolution?.name ? fields?.resolution?.name : null,
            resolutionDescription: fields?.resolution?.description ? fields?.resolution?.description : null,
            subtasks: fields?.subtasks?.length > 0 ? getSubtasksReduced(fields?.subtasks) : null
        };
    }
};

/**
 * Check if date is between now and an expiry date that is set in the env prop PROJECT_ISSUE_CACHE_EXPIRY
 * @param {*} testDateTime 
 */
export const projectIssueCacheExpired = (testDateTime) => {
    if (testDateTime) {
        var now = new Date();
        const expiryDate = new Date().setMinutes(now.getMinutes() - getProjectIssueCacheExpiry());
        return !isDateTimeBetween(now, expiryDate, testDateTime);
    }
    return true;
};

/**
 * Check each project issue cache entry if the date is between now and an expiry date that is set in the env prop PROJECT_ISSUE_CACHE_EXPIRY
 * @param {Array} issueCache 
 */
export const sanitizeProjectIssueCache = async (issueCache) => {
    if (Array.isArray(issueCache)) {
        return issueCache.filter((cacheEntry) => !projectIssueCacheExpired(cacheEntry?.lastUpdated));
    }
    return [];
};




// WEBPACK FOOTER //
// ./services/projectIssueService.js